import React, { forwardRef } from 'react';
import { FlexBetween } from '../../layout/FlexBetween/FlexBetween';
import { FlexCenter } from '../../layout/FlexCenter/FlexCenter';
import { Spacing } from '../../layout/Spacing/Spacing';
import IconComponent from '../../shared/IconComponents/IconComponent';
import { CleanButton } from '../../ui/CleanButton';
import { TextCustom } from '../../ui/TextCustom';

// Definisanje tipa za props
interface IChatBotTitleBarProps {
    setShowChat: React.Dispatch<React.SetStateAction<boolean>>;
}

// Definisanje komponente sa forwardRef
const ChatBotTitleBar = forwardRef<HTMLDivElement, IChatBotTitleBarProps>(({ setShowChat }, ref) => {
    return (
        <div ref={ref} className="chat-bot__title-bar" style={{ backgroundColor: '#002878' }}>
            <Spacing marginSpacing="none" paddingSpacing="l">
                <FlexBetween>
                    <FlexCenter position="start" direction="v">
                        <IconComponent size={2} iconName={'InBot'} />
                        <TextCustom color="white" size={1.6}>
                            InBot
                        </TextCustom>
                    </FlexCenter>
                    <CleanButton func={() => setShowChat(false)}>
                        <IconComponent size={1.5} iconName={'ChatBot_close'} />
                    </CleanButton>
                </FlexBetween>
            </Spacing>
        </div>
    );
});

ChatBotTitleBar.displayName = 'ChatBotTitleBar';

export default ChatBotTitleBar;
